module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('topnav', {
    attrs: {
      "keywords": _vm.keyword,
      "toptype": _vm.toptype,
      "types": "5",
      "isSearch": _vm.path
    },
    on: {
      "tosearch": _vm.tosearch
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "min-height": "600px"
    }
  }, [_c('div', {
    staticClass: "marginauto conwidth topall"
  }, [_c('div', {
    staticClass: "flex justify-start align-start"
  }, [_c('div', {
    staticStyle: {
      "color": "#959595",
      "font-size": "16px",
      "margin-right": "15px",
      "line-height": "37px",
      "width": "100px"
    }
  }, [_vm._v("企业类型：")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-start align-center flex-wrap"
  }, _vm._l((_vm.sortlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "topone pointer",
      class: item.checked ? 'active' : '',
      on: {
        "click": function($event) {
          return _vm.tabchange(item.id, index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "response bggray",
    staticStyle: {
      "min-height": "450px"
    }
  }, [_c('div', {
    staticClass: "marginauto comswidth"
  }, [_c('div', {
    staticClass: "dflex animated slideInLeft flex-wrap align-center justify-start"
  }, _vm._l((_vm.list), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "bg-white marone hvr-float martwo"
    }, [_c('div', {
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "flex align-center",
      staticStyle: {
        "width": "90px",
        "height": "90px"
      }
    }, [_c('el-image', {
      staticStyle: {
        "width": "90px",
        "height": "90px"
      },
      attrs: {
        "src": _vm._f("addurl")(item.shop_logo),
        "fit": "cover"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "padding-left": "15px",
        "height": "90px",
        "padding-top": "10px",
        "width": "70%"
      }
    }, [_c('div', {
      staticClass: "text-cut",
      staticStyle: {
        "color": "#262626",
        "font-size": "21px",
        "margin-bottom": "15px"
      }
    }, [_vm._v(_vm._s(item.shop_name))]), _vm._v(" "), _c('div', {
      staticClass: "text-cut response",
      staticStyle: {
        "color": "#9c9c9c",
        "font-size": "20px"
      }
    }, [_vm._v(_vm._s(item.add_detail))])])]), _vm._v(" "), _c('div', {
      staticClass: "flex justify-between align-center margin-top"
    }, [_c('div', {
      staticStyle: {
        "color": "#1b1b1b",
        "font-size": "18px"
      }
    }, [_vm._v("\n                                浏览 "), _c('span', {
      staticStyle: {
        "color": "#ff9703"
      }
    }, [_vm._v(_vm._s(item.see_number))])]), _vm._v(" "), _c('div', {
      staticClass: "dbtn pointer",
      on: {
        "click": function($event) {
          return _vm.todetail(item.id)
        }
      }
    }, [_vm._v("\n                                详情\n                            ")])])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "text-center response"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "prev, pager, next",
      "pager-count": _vm.pagerCount,
      "hide-on-single-page": true,
      "page-size": _vm.pagesize,
      "current-page": _vm.currentPage,
      "total": _vm.totalnum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])]), _vm._v(" "), (!_vm.list.length && !_vm.load) ? _c('div', {}, [_c('el-empty', {
    attrs: {
      "description": "暂无数据"
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-994a8ea4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/company_list.vue
// module id = 414
// module chunks = 1